export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getCompanyArticleList: function getCompanyArticleList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/company/get",
        method: "get",
        params: data
      });
    },
    getCompanyArticleInfo: function getCompanyArticleInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/company/getInfo",
        method: "get",
        params: data
      });
    },
    addCompanyArticle: function addCompanyArticle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/company/create",
        method: "post",
        data: data
      });
    },
    updateCompanyArticle: function updateCompanyArticle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/company/update",
        method: "post",
        data: data
      });
    },
    deleteCompanyArticle: function deleteCompanyArticle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/company/delete",
        method: "post",
        data: data
      });
    }
  };
});